export default {
  GOOGLE_TRACKING_ID: 'UA-107321473-3',
  CRISP_WEBSITE_ID: '90ce76df-2852-47c9-bbb2-20fea25cc33e',
  SENTRY_DSN: 'https://75efb6f1db7642118bb42b08328647d9@sentry.io/1479495',
  MIXPANEL: '714b9721dbddc10886d7e6e18c2af597',
}
